<template>
  <div class="wallet-item" @click="connectWallet">
    <div
      v-if="wallet"
      class="wallet-icons"
    >
      <img
        v-for="(item, index) in wallet.walletIconList"
        :key="`evm-${index}`"
        :class="[
          wallet.walletIconList.length === 1 ? 'normal' : '',
          walletStore.walletInfo[wallet.network] ? 'connected' : '',
        ]"
        :src="item.logo"
      />
    </div>
    <div class="wallet-info" v-if="wallet">
      <p class="wallet-info-title">{{ wallet.walletName }}</p>
      <p class="wallet-info-desc">{{ wallet.walletDesc }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useWalletStore } from '../../stores/wallet';
const walletStore = useWalletStore();
import emitter from '../../utils/bus';
const props = defineProps({
  wallet: {
    type: Object,
  },
});

const connectWallet = () => {
  // console.log('wallet', props.wallet);
  if (props.wallet) {
    emitter.emit('connect-wallet', props.wallet.network);
    emitter.emit('close-wallet-panel');
  }
}
</script>

<style lang="scss" scoped>
.wallet-item {
  position: relative;
  height: 60px;
  border: 1px solid var(--wallet-item-border);
  border-radius: 31px;
  float: left;
  display: flex;
  align-items: center;
  padding-left: 8px;
  cursor: pointer;
  &:after {
    content: '';
    background: url('../../assets/wallet/right-arrow.png');
    background-size: 100% 100%;
    width: 8.5px;
    height: 8.5px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 15.76px;
    margin: auto;
  }
  .wallet-icons {
    display: flex;
    img {
      margin-right: -14px;
      width: 44px;
      height: 45px;
    }
    .normal {
      margin-right: 0;
      opacity: 0.5;
    }
    .connected {
      opacity: 1;
    }
    :nth-child(1) {
      z-index: 10;
    }
    :nth-child(2) {
      z-index: 9;
    }
    :nth-child(3) {
      z-index: 8;
    }
    :nth-child(4) {
      z-index: 7;
      margin-right: 0;
    }
  }
  .wallet-info {
    margin-left: 6px;
    font-size: 12px;
    .wallet-info-title {
      font-weight: bold;
    }
    .wallet-info-desc {
      transform: scale(0.75);
      transform-origin: 0 center;
      margin-top: 2px;
      color: var(--color-4);
      width: 130%;
    }
  }
}

@media screen and (max-width: 767px) {
  .wallet-item {
    height: 47px;
    &::after {
      width: 7px;
      height: 7px;
    }
    .wallet-icons {
      img {
        margin-right: -11px;
        width: 34px;
        height: 35px;
      }
    }
    .wallet-info {
      transform: scale(0.66);
      transform-origin: 0 center;
      .wallet-info-title {
        width: 150%;
        font-size: 15px;
      }
      .wallet-info-desc {
        width: 150%;
        transform: scale(1);
      }
    }
  }
}
</style>
